import React from "react";
import ProfileCard from "../common/profileCard";
import InstitutionSidebar from "../common/institutionSidebar";
import ChangePasswordForm from "../../common/ChangePasswordForm";

const InstitutionChangePassword = () => {
    return (
        <div className="content">
            <div className="container">
                <ProfileCard />
                <div className="row">
                    <InstitutionSidebar />
                    <div className="col-lg-9">
                        <div className="mb-3">
                            <h5>Change Password</h5>
                        </div>
                        <ChangePasswordForm />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InstitutionChangePassword;
